module.exports = __webpack_public_path__ + "static/slack-b940e3d17fa0c61a733a3209226b05da.png";